import React, { useEffect, useState } from 'react'

//Components
import MainCard from '../../../components/MainCard/MainCard';

//API
import tipoAutoInfracao_api from '../../../api/tipoAutoInfracao_api';

//Context
import { useAuth } from '../../../context/auth';

//Helpers
import { showMessage } from '../../../helpers/message';
import NovaAutoInfracao from './NovaAutoInfracao';
import { Col, Row } from 'reactstrap';

export default function FichaAutoInfracao({ id, btnVoltar, permissao }) {
  const {setLoading} = useAuth();

  //Estado que guarda os dados que vão ser apresentados na tela
   const [autoDeInfracao, setAutoDeInfracao] = useState({});

   //Estado que controla a apresentação da tela de edição
   const [autoInfracao_Id, setAutoInfracao_Id] = useState(null);

   //Função de clique do botão de editar
   const editar = () => setAutoInfracao_Id(id);
    
   //Carrega os dados da prefeitura
   async function loadItem (id) {
       setLoading(true);
       setAutoInfracao_Id(null);

       try {
          setLoading(true);
          const { data } = await tipoAutoInfracao_api.GetItem(id);
          setAutoDeInfracao(data);
       }catch(ex) {
          showMessage("Error", ex.message, "error", null);
       }finally {
          setLoading(false);
       } 
   };

   useEffect(() => {
       if(id) loadItem(id);
   }, [id]);
   
   //Controle da apresentação da tela de editar
   if (!!autoInfracao_Id) {
       return <NovaAutoInfracao 
              id={autoInfracao_Id}
              btnVoltar={() => {
                setAutoInfracao_Id(null);
                btnVoltar(); }
              } 
       />
   } 

   return (
       <> 
          <MainCard 
            btnVoltar={btnVoltar} 
            btnEditar={permissao === "Editar" ? editar : null}
          >
            {!!autoDeInfracao && 
              <div style={{ color: "#666" }}>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Destino: </span> {autoDeInfracao.destino ? "Sim" : "Não"}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Gerador: </span> {autoDeInfracao.gerador ? "Sim" : "Não"}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Transportador: </span> {autoDeInfracao.transportador ? "Sim" : "Não"}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Status: </span> {autoDeInfracao.status}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Valor da multa: </span> {
                            autoDeInfracao.valorMulta ? 
                            autoDeInfracao.valorMulta.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }) : 
                            "R$ 0,00"
                          }</p>
                    </Col>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Fato constitutivo: </span> {autoDeInfracao.fatoConstitutivo}</p>
                    </Col>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Preceitos legais: </span> {autoDeInfracao.preceitosLegais}</p>
                    </Col>
                </Row>  
              </div>
            }
          </MainCard>
       </>
   )
}
